import * as React from 'react';
import { toast } from 'react-toastify';
import FloatingMessageBar from '../FloatingMessageBar';
import './toast.css';

export const defaultToastOptions = {
  closeButton: false,
  draggable: false,
  hideProgressBar: true,
  position: 'top-center',
};

const showSuccessToast = (title, text = null, options = null) => {
  toast(
    () => (
      <FloatingMessageBar
        showCloseButton
        errors={[
          {
            kind: 'success',
            title,
            text,
          },
        ]}
        isRounded
      />
    ),
    { ...defaultToastOptions, ...options },
  );
};

const showAlertToast = (title, text, options = null, className = '') => {
  toast(
    () => (
      <FloatingMessageBar
        className={className}
        showCloseButton
        errors={[
          {
            kind: 'alert',
            title,
            text,
          },
        ]}
        isRounded
      />
    ),
    { ...defaultToastOptions, ...options },
  );
};

export { showSuccessToast, showAlertToast };
